Object.defineProperty(exports, '__esModule', { value: true });

const utils = require('@sentry/utils');

const WINDOW = utils.GLOBAL_OBJ

;

exports.WINDOW = WINDOW;
//# sourceMappingURL=types.js.map
